import React from 'react'
import { RouteComponentProps } from 'react-router'
import { Route, Switch } from 'react-router-dom'
import GoodsLibrary from './goods-library/goods-library'

const path = '/main/goods/goodStorage'

export const GOODS_GOODS_LIBRARY = path + '/goodsLibrary'
export const GOODS_GOODS_SHELF = path + '/goodsShelf'

export default (props: RouteComponentProps) => {
    return (
        <Switch>
            <Route path={props.match.path + '/goodsLibrary'} component={GoodsLibrary}></Route>
        </Switch>
    )
}
